import { useSelector } from 'react-redux'
import { triggerEventTarget } from 'libraries/front-end-core/helpers/document'
import { scrollTo } from 'libraries/front-end-core/services/WindowService'
import selectDeviceType from 'redux/selectors/selectDeviceType'

const useClickEvents = ({ pageToggleRight }) => {
  const { isMobile } = useSelector(selectDeviceType)

  const handleClick = (evt) => {
    triggerEventTarget(evt.target, {
      'a[href]': ({ hash }) => hash && scrollTo({
        pageId: document.querySelector('.scrolling-container').id,
        id: hash,
        useWindowScrollTo: isMobile
      })
    })
  }

  return { handleClick }
}

export default useClickEvents
